import script from "./AgentToolCall.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentToolCall.vue?vue&type=script&setup=true&lang=js"

import "./AgentToolCall.vue?vue&type=style&index=0&id=7da5f64d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7da5f64d"]])

export default __exports__